import {GetStaticProps, GetStaticPropsContext} from 'next';
import Head from 'next/head';

import {RENDER_MODES} from '@udemy/nextjs-core';

import {getLayout} from 'src/components/layout';
import {HomePage} from 'src/features/home/home-page';
import {getCompactTranslations} from 'src/lib-server/locale.server';
import {FOUR_HOURS} from 'src/lib/constants';
import {AppContextData, PageProps} from 'src/types/page-props';

import {getStaticAppContext} from '../../api/context.api';

export const getStaticProps: GetStaticProps = async (context: GetStaticPropsContext) => {
    const locale = context.locale as string;
    const translations = await getCompactTranslations(locale);

    // Resolve appContext
    const [staticData] = await Promise.all([getStaticAppContext({locale})]);

    const appContext: AppContextData = Object.assign({}, staticData);

    return {
        props: {
            appContext,
            locale,
            pageKey: 'jp_campaign_it_certification',
            renderMode: RENDER_MODES.ISR,
            translations,
        },
        revalidate: FOUR_HOURS,
    };
};

const ITCertificationPage = (props: PageProps) => (
    <>
        <Head>
            <title>
                効率良く学べるおすすめIT資格対策講座 | Udemy
                世界最大級のオンライン学習プラットフォーム
            </title>
        </Head>
        <HomePage {...props} />
    </>
);

ITCertificationPage.getLayout = getLayout;

export default ITCertificationPage;
